import type { RunState } from '../api/types';

/**
 * Which `participant.runStateChange.*` message a transition deserves.
 *
 * Keyed on the new state alone, coming back from a pause announced "the run has
 * begun" — the same line a start gets. The participant run-state hook hands over
 * the previous state precisely so the two can be told apart.
 *
 * Lives beside RunShell rather than inside it: a component file that also
 * exports helpers breaks fast refresh (react-refresh/only-export-components).
 */
export function runStateToastKey(next: RunState, previous: RunState | null): string {
  if (next === 'active' && previous === 'paused') return 'resumed';
  return next;
}
